// auto-generated by Typewriter template _models.tst from PortCall.Models\Utils\Price.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// PriceData is the class that Price serializes to/from
export interface PriceData {
	
	
    Cur : string;
    Num : number;
}

// PriceOptions is the class which may be passed to the Price constructor to define optional initial data values
export interface PriceOptions {
	
	
    Cur? : string;
    Num? : number;
}

export class Price {
	
	
    public Cur : DataSignal<string>;
    public Num : DataSignal<number>;

    constructor();
    constructor(data : PriceOptions);
    constructor(data: PriceOptions | null = null) {
	    
	    
        this.Cur = jsonableObservable(S.value<string>(data && data.Cur !== undefined ? data.Cur : ''));
        this.Num = jsonableObservable(S.value<number>(data && data.Num !== undefined ? data.Num : 0));
    }

    static key(obj : Price) {
        return ;
    }
    
    static dataKey(obj : PriceOptions) {
        return ;
    }

    static update(obj : Price, data : PriceOptions) {
        S.freeze(() => {
	        
	        
            if (data.Cur !== undefined) obj.Cur(data.Cur);
            if (data.Num !== undefined) obj.Num(data.Num);
        });
    }
}

// NullablePriceData is the class that NullablePrice serializes to/from
export interface NullablePriceData {
	
	
    Cur : string | null;
    Num : number | null;
}

// NullablePriceOptions is the class which may be passed to the NullablePrice constructor to define optional initial data values
export interface NullablePriceOptions {
	
	
    Cur? : string | null;
    Num? : number | null;
}

export class NullablePrice {
	
	
    public Cur : DataSignal<string | null>;
    public Num : DataSignal<number | null>;

    constructor();
    constructor(data : NullablePriceOptions);
    constructor(data: NullablePriceOptions | null = null) {
	    
	    
        this.Cur = jsonableObservable(S.value<string | null>(data && data.Cur !== undefined ? data.Cur : null));
        this.Num = jsonableObservable(S.value<number | null>(data && data.Num !== undefined ? data.Num : null));
    }

    static key(obj : NullablePrice) {
        return ;
    }
    
    static dataKey(obj : NullablePriceOptions) {
        return ;
    }

    static update(obj : NullablePrice, data : NullablePriceOptions) {
        S.freeze(() => {
	        
	        
            if (data.Cur !== undefined) obj.Cur(data.Cur);
            if (data.Num !== undefined) obj.Num(data.Num);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/Price.ts